export default "<div >\n    <ng-template dw-dynamic>\n        \n    </ng-template>\n</div>\n"